// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".single-legend-enter-active[data-v-49440a60],.single-legend-leave-active[data-v-49440a60]{transition-duration:.15s;transition-property:transform,opacity;transition-timing-function:ease-out}.single-legend-enter[data-v-49440a60],.single-legend-leave-to[data-v-49440a60]{opacity:0;transform:scale(1.025)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
